import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { CampaignType } from "@front/m19-api-client";
import { StrategyPageService } from "../strategy-page.service";
import { SdStrategyTargetingTableComponent } from "./sd-strategy-targeting-table.component";

@Component({
  selector: "app-strategy-page-sd-targetings",
  imports: [SdStrategyTargetingTableComponent],
  template: ` <app-sd-strategy-targeting-table [strategy]="strategy()" /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyPageSdTargetingsComponent {
  private readonly strategyPageService = inject<StrategyPageService<CampaignType.SD>>(StrategyPageService);
  strategy = this.strategyPageService.strategy;
}
